/** Loading (design v2 § 9): rows shaped like the content — text bars on ruled lines,
 * breathing between --rule and --paper-sunk. No spinners. */
const WIDTHS = ["62%", "38%", "54%", "30%", "58%", "44%"];

export function SkeletonRows({ rows = 3, label = "Loading" }: { rows?: number; label?: string }) {
  return (
    <div className="skeleton-rows" role="status" aria-label={label}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skeleton-rows__row">
          <span className="skeleton" style={{ width: WIDTHS[(i * 2) % WIDTHS.length] }} />
          <span
            className="skeleton skeleton--small"
            style={{ width: WIDTHS[(i * 2 + 1) % WIDTHS.length] }}
          />
        </div>
      ))}
    </div>
  );
}
